import { defineMessages } from 'react-intl';

export const uniformFormMessages = defineMessages({
	firstName: { id: 'uniform.form.field.firstName', defaultMessage: 'First name' },
	lastName: { id: 'uniform.form.field.lastName', defaultMessage: 'Last name' },
	email: { id: 'uniform.form.field.email', defaultMessage: 'Email' },
	company: { id: 'uniform.form.field.company', defaultMessage: 'Company' },
	phone: { id: 'uniform.form.field.phone', defaultMessage: 'Phone number' },
	honeypot: { id: 'uniform.form.field.honeypot', defaultMessage: 'Email confirmation' },
	required: { id: 'uniform.form.validation.required', defaultMessage: 'This field is required.' },
	firstNameRequired: {
		id: 'uniform.form.validation.firstNameRequired',
		defaultMessage: 'Your first name is required.',
	},
	lastNameRequired: {
		id: 'uniform.form.validation.lastNameRequired',
		defaultMessage: 'Your last name is required.',
	},
	companyRequired: {
		id: 'uniform.form.validation.companyRequired',
		defaultMessage: 'Please enter a company.',
	},
	phoneRequired: {
		id: 'uniform.form.validation.phoneRequired',
		defaultMessage: 'Please provide phone number.',
	},
	invalidEmail: {
		id: 'uniform.form.validation.invalidEmail',
		defaultMessage: 'Enter a valid email address.',
	},
	businessEmail: {
		id: 'uniform.form.validation.businessEmail',
		defaultMessage: 'Enter a business email address.',
	},
	selectPlaceholder: { id: 'uniform.form.selectPlaceholder', defaultMessage: 'Select an option' },
	submit: { id: 'uniform.form.submit', defaultMessage: 'Submit' },
	submitError: {
		id: 'uniform.form.submitError',
		defaultMessage: 'There has been an error submitting - please try again later',
	},
	configurationError: {
		id: 'uniform.form.configurationError',
		defaultMessage: 'This form is not configured correctly.',
	},
	privacyPolicy: {
		id: 'uniform.form.consent.privacyPolicy',
		defaultMessage: 'By submitting this form, I acknowledge the Atlassian Privacy Policy.',
	},
	generalMarketingOptIn: {
		id: 'uniform.form.consent.generalMarketingOptIn',
		defaultMessage: 'Yes, I would like to receive marketing communications from Atlassian.',
	},
	termsOfService: {
		id: 'uniform.form.consent.termsOfService',
		defaultMessage: 'By submitting this form, I agree to the Atlassian Terms of Service.',
	},
	eapTermsOfService: {
		id: 'uniform.form.consent.eapTermsOfService',
		defaultMessage:
			'By submitting this form, I agree to the Early Access Program Terms of Service.',
	},
	eapVirtualAgentTerms: {
		id: 'uniform.form.consent.eapVirtualAgentTerms',
		defaultMessage:
			'By submitting this form, I agree to the Early Access Program terms and conditions.',
	},
});
